import React from 'react';

import searchIcon from 'assets/images/icons/search-icon.svg';

import * as T from './interfaces';
import * as S from './styles';

export const Input = ({
  name,
  icon,
  error,
  message,
  disabled = false,
  placeholder,
  ids,
  loading,
  focused,
  label,
  type,
  isFilled,
  ...rest
}: T.IInputProps) => (
  <S.Wrapper
    data-testid={ids.wrapper}
    id={ids.wrapper}
    error={!!error}
    focused={focused}
    disabled={disabled || loading}
    isFilled={isFilled}
    loading={loading ? 1 : 0}
    type={type}
  >
    <S.InputWrapper>
      {type === 'search' && (
        <S.Icon data-testid={ids.iconSearch}>
          <img src={searchIcon} alt="icone de lupa" />
        </S.Icon>
      )}
      <S.Input
        id={ids.input}
        data-testid={ids.input}
        name={name}
        disabled={disabled || loading}
        type={type}
        {...rest}
      />
      <S.Label htmlFor={name}>
        {placeholder}
        <S.AccessibilityLabel>{label}</S.AccessibilityLabel>
      </S.Label>
      {icon && isFilled && !loading ? (
        <S.Icon data-testid={ids.icon}>{icon}</S.Icon>
      ) : (
        loading && (
          <div className="loader-icon">
            <div className="loader" data-testid={ids.load} />
          </div>
        )
      )}
    </S.InputWrapper>
    <S.BoxMessage id={ids.message} data-testid={ids.message}>
      {!!error && error}
      {!error && !!message && message}
    </S.BoxMessage>
  </S.Wrapper>
);
